var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.054,
    height: 31.213,
    viewBox: "0 0 38.054 31.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 38.054,
    height: 31.213,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M27.363,70.426V68.871a.923.923,0,0,0-.857-.984,1.184,1.184,0,0,0-.989.44.91.91,0,0,0-.819-.441.819.819,0,0,0-.726.368v-.306h-.539v2.478h.544V69.063a.581.581,0,0,1,.5-.654.6.6,0,0,1,.11,0c.358,0,.539.233.539.653v1.379h.544V69.063a.583.583,0,0,1,.5-.654.57.57,0,0,1,.1,0c.368,0,.544.233.544.653v1.379Zm8.054-2.478H34.53V67.2h-.544v.752h-.493v.493H34v1.14c0,.575.223.918.861.918a1.264,1.264,0,0,0,.674-.192l-.156-.461a1,1,0,0,1-.477.14c-.259,0-.358-.166-.358-.415v-1.13h.881Zm4.6-.062a.73.73,0,0,0-.653.363v-.3h-.534v2.478h.539v-1.39c0-.41.176-.638.518-.638a.879.879,0,0,1,.337.062l.166-.518a1.162,1.162,0,0,0-.384-.068Zm-6.952.259a1.854,1.854,0,0,0-1.011-.259c-.627,0-1.037.3-1.037.793,0,.4.3.653.856.731l.259.036c.3.042.435.119.435.259,0,.192-.2.3-.565.3a1.322,1.322,0,0,1-.824-.259l-.259.42a1.787,1.787,0,0,0,1.073.321c.716,0,1.13-.337,1.13-.809s-.326-.664-.866-.741L32,68.9c-.233-.031-.42-.078-.42-.244s.176-.29.472-.29a1.6,1.6,0,0,1,.778.213ZM47.5,67.886a.73.73,0,0,0-.653.363v-.3h-.534v2.478h.539v-1.39c0-.41.176-.638.518-.638a.879.879,0,0,1,.337.062l.166-.518a1.162,1.162,0,0,0-.384-.068Zm-6.947,1.3a1.252,1.252,0,0,0,1.205,1.3c.039,0,.078,0,.117,0a1.3,1.3,0,0,0,.892-.3l-.259-.435a1.09,1.09,0,0,1-.648.223.8.8,0,0,1,0-1.586,1.088,1.088,0,0,1,.648.223l.259-.436a1.3,1.3,0,0,0-.892-.3,1.253,1.253,0,0,0-1.321,1.179q0,.059,0,.117Zm5.05,0V67.948h-.539v.3a.941.941,0,0,0-.778-.363,1.3,1.3,0,1,0,0,2.592.941.941,0,0,0,.778-.363v.3h.539Zm-2.006,0a.741.741,0,1,1,0,.059C43.6,69.221,43.6,69.2,43.6,69.182Zm-6.507-1.3a1.3,1.3,0,0,0,.036,2.592h0a1.506,1.506,0,0,0,1.029-.337l-.259-.4A1.182,1.182,0,0,1,37.18,70a.687.687,0,0,1-.741-.607h1.84v-.207a1.178,1.178,0,0,0-1.177-1.3Zm0,.482a.615.615,0,0,1,.628.6h-1.3a.638.638,0,0,1,.658-.6Zm13.508.819V66.953h-.518v1.3a.941.941,0,0,0-.778-.363,1.3,1.3,0,1,0,0,2.592.941.941,0,0,0,.778-.363v.3H50.6Zm.9.879a.262.262,0,0,1,.1.018.256.256,0,0,1,.08.052.259.259,0,0,1,.054.078.241.241,0,0,1,0,.192.259.259,0,0,1-.054.078.256.256,0,0,1-.08.052.235.235,0,0,1-.1.021.259.259,0,0,1-.233-.15.244.244,0,0,1,0-.192.259.259,0,0,1,.054-.078.252.252,0,0,1,.08-.052.263.263,0,0,1,.106-.018Zm0,.438a.18.18,0,0,0,.075-.015.2.2,0,0,0,.06-.042.192.192,0,0,0,0-.259.2.2,0,0,0-.06-.041.186.186,0,0,0-.075-.016.2.2,0,0,0-.075.016.187.187,0,0,0,.083.358Zm.016-.308a.1.1,0,0,1,.068.021.066.066,0,0,1,.023.054.062.062,0,0,1-.018.047.091.091,0,0,1-.054.023l.075.086h-.06l-.07-.086h-.023v.086h-.049V70.2Zm-.057.044V70.3h.057a.055.055,0,0,0,.031,0,.025.025,0,0,0,0-.023.025.025,0,0,0,0-.023.055.055,0,0,0-.031,0Zm-2.851-1.052a.745.745,0,1,1,0,.059C48.607,69.226,48.607,69.207,48.609,69.187Zm-18.205,0V67.948h-.539v.3a.94.94,0,0,0-.778-.363,1.3,1.3,0,1,0,0,2.592.94.94,0,0,0,.778-.363v.3H30.4Zm-2.006,0a.692.692,0,1,1-.007.064c0-.021,0-.043,0-.064Z",
    transform: "translate(-17.94 -43.141)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": " Group ",
    transform: "translate(3.928 3.927)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 8.166,
    height: 14.675,
    transform: "translate(11.016 1.996)",
    fill: "#ed4815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": " Path ",
    d: "M30.8,23.282a9.317,9.317,0,0,1,3.565-7.339,9.332,9.332,0,1,0,0,14.675A9.316,9.316,0,0,1,30.8,23.282Z",
    transform: "translate(-19.262 -13.947)",
    fill: "#e1001a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M74.611,23.28a9.332,9.332,0,0,1-15.1,7.336,9.333,9.333,0,0,0,0-14.675,9.332,9.332,0,0,1,15.1,7.336Z",
    transform: "translate(-44.412 -13.945)",
    fill: "#f78a0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M97.074,53.634v-.3H97.2v-.062h-.309v.062h.132v.3Zm.6,0v-.363h-.093l-.109.259-.109-.259h-.083v.363h.067v-.272l.1.236h.07l.1-.236v.275Z",
    transform: "translate(-67.767 -38.518)",
    fill: "#f78a0b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.117ad423.svg";
export { ForwardRef as ReactComponent };